import { Box, Heading } from '@hover/blueprint';
import React from 'react';
import styled from 'styled-components';

import { useLocation, useSegment, useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Route } from 'src/shared/route';
import {
  Page,
  homeownerIdentified,
  professionalIdentified,
} from 'src/shared/telemetry';

import { HomeownerImage } from '../images/HomeownerImage';
import { ProfessionalImage } from '../images/ProfessionalImage';

import { SignUpLink } from './SignUpLink';

enum GridArea {
  HEADER = 'header',
  PROFESSIONAL = 'professional',
  HOMEOWNER = 'homeowner',
}

const tabletGridAreas = `
  "${GridArea.HEADER} ${GridArea.HEADER}"
  "${GridArea.PROFESSIONAL} ${GridArea.HOMEOWNER}"
`;

const mobileGridAreas = `
  "${GridArea.HEADER}"
  "${GridArea.PROFESSIONAL}"
  "${GridArea.HOMEOWNER}"
`;

const Container = styled(Box)`
  padding: 10vh 6vh 0;
  height: 70%;
`;

const SignUpFork = () => {
  const t = useTranslate(TranslationNamespace.SIGN_UP);
  const { identify } = useSegment();
  const { search } = useLocation();

  const onHomeownerSignUpLinkClick = async () => {
    homeownerIdentified({
      button_text: t('homeowners'),
      page_or_screen_name: Page.SIGNUP__FORK,
      primary_cta: true,
    });
    return identify({ account_type: 'homeowner' });
  };

  const onProfessionalSignUpLinkClick = async () => {
    professionalIdentified({
      button_text: t('contractorsAndAdjusters'),
      page_or_screen_name: Page.SIGNUP__FORK,
      primary_cta: true,
    });
    return identify({ account_type: 'pro' });
  };

  return (
    <Container
      alignItems="center"
      display="grid"
      gridColumnGap="5vw"
      gridRowGap="3vh"
      gridTemplateAreas={{
        mobile: mobileGridAreas,
        tablet: tabletGridAreas,
      }}
      gridTemplateColumns={{
        mobile: 'minmax(10rem, 30rem)',
        tablet: 'repeat(2, minmax(10rem, 40%))',
      }}
      gridTemplateRows="auto 1fr"
      justifyContent="space-around"
      paddingBottom={800}
      paddingTop={600}
      paddingX={600}
      width="100%"
    >
      <Heading
        color="neutral700"
        gridArea="header"
        marginBottom={0}
        marginLeft={300}
        size={500}
      >
        {t('createAnAccount')}
      </Heading>
      <SignUpLink
        alignSelf="end"
        description={t('contractorDescription')}
        gridArea="professional"
        label={t('selectToCreateAnAccountAsAProfessional')}
        onClick={onProfessionalSignUpLinkClick}
        paddingTop={600}
        testId="professional-signup-link"
        title={t('contractorsAndAdjusters')}
        to={Route.SIGN_UP_PROFESSIONAL.path + search}
      >
        <ProfessionalImage />
      </SignUpLink>
      <SignUpLink
        alignSelf="end"
        description={t('homeownerDescription')}
        gridArea="homeowner"
        label={t('selectToCreateAnAccountAsAHomeowner')}
        onClick={onHomeownerSignUpLinkClick}
        testId="homeowner-signup-link"
        title={t('homeowners')}
        to={Route.SIGN_UP_HOMEOWNER.path + search}
      >
        <HomeownerImage />
      </SignUpLink>
    </Container>
  );
};

export { SignUpFork };
